import { Tooltip as TooltipPrimitive } from "radix-ui";
import type { ComponentProps } from "react";

export const Tooltip = (props: ComponentProps<typeof TooltipPrimitive.Root>) => (
  <TooltipPrimitive.Root data-slot="tooltip" {...props} />
);
